import Component from 'navigation/component/Component'
import './ColorLabel.scss'

type ColorLabelType = {}

class ColorLabel extends Component<ColorLabelType> {}
export default ColorLabel
